import React from 'react';
import cn from 'classnames';

export const ProgressBar = (props) => {
    console.log('props', props.progressWidth);
    const totalQuestion = props.surveyQuestion.length;
    const formattedNumber =(num)=>{
      const dec = num - Math.floor(num);
      num = num - dec;
      return num.toString().slice(-2) + dec.toString().slice(1);

    }

  return (
     <div className={cn('col-12 m-0 row py-0 justify-content-center align-items-center', props.isLandScape ? 'px-0' : 'h-10 pt-5 px-3' )}>
       <div className='text-left fs_20 fw-600 ' style={{width: props.isLandScape ? '8%' : '18%', color: props?.serverAppTheme?.primary_text}}><span>{ formattedNumber(props.surveyQuestion.length !== props.onQuestion ? props.onQuestion +1 : props.onQuestion)}</span><span className='px-1'>of</span><span>{formattedNumber(totalQuestion)}</span></div>

       <div style={{height:'15px', background:props?.serverAppTheme?.selector_control_color, borderRadius:'50rem', width: props.isLandScape ? '91%' : '80%'}} className={cn('rounded-pill ml-2')}>
        {/* <div className='d-flex row p-0 m-0 h-100'>
          {props?.surveyQuestion?.length && props?.surveyQuestion?.map((el, i)=>{
            return (
            <div className='rounded-pill col p-0 h-100' style={{backgroundColor:props.onQuestion >= i ? '#0060FF' : '#4C4C4C'}}></div>
            )
          })}
          </div> */}

        <div style={{width:`${props.progressWidth}%`, backgroundColor:'#2541A4', borderBottomLeftRadius:"50rem", borderTopLeftRadius:"50rem", borderBottomRightRadius:'50rem', borderTopRightRadius:'50rem'}} className={cn('h-100', props.progressWidth === 100 && 'rounded-pill')}></div>

       </div>
     </div>
  )
}
